var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Bowser from "bowser";
import { BRANCH_KEY_DEV, BRANCH_KEY_PROD, } from "@discovery/common-dplus/lib/env";
const bowser = Bowser.getParser(window.navigator.userAgent);
export var SHARE_TYPE;
(function (SHARE_TYPE) {
    SHARE_TYPE["WHATSAPP_SHARE"] = "WHATSAPP_SHARE";
    SHARE_TYPE["SHARE"] = "SHARE";
})(SHARE_TYPE || (SHARE_TYPE = {}));
export const shareHandler = (share_type, image, descriptionM, title, shareUrl) => {
    if (window.location.hostname === "www.discoveryplus.in") {
        branch.init(BRANCH_KEY_PROD);
    }
    else {
        branch.init(BRANCH_KEY_DEV);
    }
    const shareNavigator = window.navigator;
    if (shareUrl) {
        const src = image && image.src;
        const description = descriptionM && M.fromMaybe(descriptionM, "");
        const linkData = {
            data: {
                $desktop_url: shareUrl,
                $canonical_identifier: shareUrl,
                $og_title: title,
                $og_description: description,
                $og_image_url: `${image && image.src}?w=1080`,
                $twitter_image_url: `${image && image.src}?w=1080`,
                $og_image_width: "1080",
                $og_image_height: "200",
                $twitter_title: title,
                twitter_description: description,
                $android_url: shareUrl,
                $ios_url: shareUrl,
            },
        };
        if (share_type === SHARE_TYPE.SHARE) {
            return branch.link(linkData, (err, link) => {
                console.warn(err);
                if (shareNavigator && shareNavigator.share) {
                    shareNavigator
                        .share({
                        title: title,
                        text: `Watch ${`'`}${title}${`'`} now on discovery+`,
                        url: link,
                        image: { source: src, mimeType: "image/jpeg" },
                    })
                        .then(() => console.warn("Successful share"))
                        .catch(() => console.error("Error in sharing"));
                }
                else {
                    alert("share not supported");
                }
            });
        }
        else if (share_type === SHARE_TYPE.WHATSAPP_SHARE) {
            const redirect = (linkUrl, title) => {
                const shareThroughWhatsappUrl = `whatsapp://send?text=Watch ${`'`}${title}${`'`} now on discovery+.  `;
                const whatsapp_url = shareThroughWhatsappUrl + linkUrl;
                window.location.href = whatsapp_url;
            };
            return branch.link(linkData, (err, link) => {
                link ? redirect(link, title) : console.warn(err);
            });
        }
    }
};
/** SHARE  */
export const copyToClipboard = (string) => {
    let textarea;
    let result;
    try {
        textarea = document.createElement("textarea");
        textarea.setAttribute("readonly", "true");
        textarea.setAttribute("contenteditable", "true");
        textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
        textarea.value = string;
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const range = document.createRange();
        range.selectNodeContents(textarea);
        const sel = window.getSelection();
        sel && sel.removeAllRanges();
        sel && sel.addRange(range);
        textarea.setSelectionRange(0, textarea.value.length);
        result = document.execCommand("copy");
    }
    catch (err) {
        console.error(err);
        result = null;
    }
    finally {
        textarea && document.body.removeChild(textarea);
    }
    // manual copy fallback using prompt
    if (!result) {
        const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
        const copyHotkey = isMac ? "⌘C" : "CTRL+C";
        result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
        if (!result) {
            return false;
        }
    }
    return true;
};
export const shareHandlerWithSafariSupport = (shareUrl, shareTitle, shareDesc, shareImage, setShareLink, toastHandler) => __awaiter(void 0, void 0, void 0, function* () {
    const linkData = {
        data: {
            $desktop_url: shareUrl,
            $canonical_identifier: shareUrl,
            $og_title: shareTitle,
            $og_description: shareDesc,
            $twitter_title: shareTitle,
            twitter_description: shareDesc,
            $twitter_image_url: `${shareImage}?w=1080`,
            $og_image_width: "1080",
            $og_image_height: "200",
            $og_image_url: `${shareImage}?w=1080`,
            $canonical_url: shareUrl,
            $deeplink_path: shareUrl,
        },
    };
    branch.link(linkData, (err, link) => {
        console.warn(err);
        const shareNavigator = window.navigator;
        if (window.innerWidth <= 699) {
            if (shareNavigator && shareNavigator.share) {
                shareNavigator
                    .share({
                    title: shareTitle,
                    text: shareTitle,
                    url: link,
                    image: { source: shareImage, mimeType: "image/jpeg" },
                })
                    .then(() => console.warn("Successful share"))
                    .catch(() => console.error("Error in sharing"));
            }
            else {
                alert("share not supported");
            }
        }
        else {
            const isSafari = bowser.getBrowser().name === "Safari";
            if (isSafari) {
                setShareLink(link);
            }
            else {
                const tempInput = document.createElement("input");
                tempInput.value = link;
                document.body.appendChild(tempInput);
                tempInput.select();
                document.execCommand("copy");
                tempInput && document.body.removeChild(tempInput);
                tempInput && toastHandler && toastHandler("Link copied");
            }
        }
    });
});

